import React, { useEffect, useState } from "react";
import { Button, Container, Input } from "reactstrap";
import Select from "react-select";
import Product from "../../components/user/CardProduct";
// import Fillter from "../../components/user/Fillter";
import Footer from "../../components/user/Footer";
import axios from "axios";
import { FaRegCircle, FaRegCheckCircle } from "react-icons/fa";
import { VscTerminalLinux } from "react-icons/vsc";
import { getData } from "../../api/method";
import Filter from "../../components/user/Fillter";

const token = localStorage.getItem("token_key");

function Categories() {
  const [data, setData] = useState([]);
  const [dataCategory, setDataCategory] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [leveFilter, setLeverFilter] = useState({ to: "", form: "" });
  const [sortState, setSortState] = useState("none");

  const sortMethods = {
    none: { method: undefined },
    ascending: { method: (a, b) => b.price - a.price },
    descending: { method: (a, b) => a.price - b.price },
  };

  const getProduct = async () => {
    try {
      const result = await getData("/api/Product");
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategory = async () => {
    try {
      const result = await getData("/api/Category");
      setDataCategory(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProduct();
    getCategory();
  }, []);

  const filterByCategory = (filtered) => {
    if (
      selectedCategory === null ||
      selectedCategory === undefined ||
      selectedCategory === "0"
    ) {
      return data;
    } else {
      const filteredData = filtered.filter(
        (item) => item.categoryId === +selectedCategory
      );
      return filteredData;
    }
  };

  const handleCategoryChange = (e) => {
    const input = e.currentTarget.id;

    if (input === selectedCategory) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(input);
    }
  };

  const filterByPrice = (filtered) => {
    if (!leveFilter) {
      return filtered;
    } else {
      const filteredData = filtered.filter(
        (item) =>
          (item.price * (100 - item.discount)) / 100 > leveFilter.from &&
          (item.price * (100 - item.discount)) / 100 < leveFilter.to
      );
      return filteredData;
    }
  };

  const handleApply = () => {
    if (!selectedCategory) {
      const filter = filterByPrice(data);
      setDataFilter(filter);
    } else {
      const filters = filterByPrice(dataFilter);
      setDataFilter(filters);
    }
    setLeverFilter({ to: "", from: "" });
  };

  useEffect(() => {
    const filtered = filterByCategory(data);
    setDataFilter(filtered);
  }, [+selectedCategory]);

  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">
          Categories
        </p>
      </div>

      <Container className="py-5">
        <div className="d-flex justify-content-between">
          <Filter
            handleCategoryChange={handleCategoryChange}
            selectedCategory={selectedCategory}
            dataCategory={dataCategory}
            onChangeFrom={(event) =>
              setLeverFilter({
                ...leveFilter,
                from: event.target.value,
              })
            }
            onChangeTo={(event) =>
              setLeverFilter({ ...leveFilter, to: event.target.value })
            }
            valueTo={leveFilter.to}
            valueFrom={leveFilter.from}
            handleApply={handleApply}
          />

          <div className="w-80">
            <div className="d-flex align-items-center justify-content-end mb-4">
              <span className="me-3 fs-20">Price: </span>
              <select
                name=""
                id=""
                defaultValue={"default"}
                className="border_select"
                onChange={(e) => setSortState(e.target.value)}
              >
                <option value="default" disabled>
                  None
                </option>
                <option value="ascending">Ascending</option>
                <option value="descending">Descending</option>
              </select>
            </div>

            <div className="list_product d-flex justify-content-start flex-column">
              {(!selectedCategory ? data : dataFilter).length > 0 ? (
                <Product
                  data={(!selectedCategory ? data : dataFilter).sort(
                    sortMethods[sortState].method
                  )}
                />
              ) : (
                <div className="d-flex align-items-center w-100 py-5 justify-content-center">
                  <VscTerminalLinux className="fs-1" />
                  <p className="fs-24">No Product</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>

      <Footer />
    </div>
  );
}

export default Categories;
